import React from "react";
import useLocalLicense from "../hooks/useLocalLicense";

interface ILicenseValidChecker {
  fallbackContent?: React.ReactNode;
}

const LicenseValidChecker: React.FunctionComponent<ILicenseValidChecker> = ({
  children,
  fallbackContent
}) => {
  const { isLocalLicenseValidOrOnline, isLocalLicenseLoading } =
    useLocalLicense();

  const fallbackContentWhenNotLoading = isLocalLicenseLoading
    ? null
    : fallbackContent;

  return (
    <>
      {isLocalLicenseValidOrOnline ? children : fallbackContentWhenNotLoading}
    </>
  );
};

export default LicenseValidChecker;
